import { z } from 'zod';

const mergeChallengeDataSchema = z.object({
  transferred: z.number(),
  skippedDuplicates: z.number(),
  clipsTransferred: z.number(),
});

export const mergeChallengeResponseSchema = z.object({
  success: z.boolean(),
  data: mergeChallengeDataSchema,
});

export type IMergeChallengeResponse = z.infer<typeof mergeChallengeResponseSchema>;
